import { render, staticRenderFns } from "./CameraApp.vue?vue&type=template&id=75c28587&scoped=true"
import script from "./CameraApp.vue?vue&type=script&lang=ts"
export * from "./CameraApp.vue?vue&type=script&lang=ts"
import style0 from "./CameraApp.vue?vue&type=style&index=0&id=75c28587&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c28587",
  null
  
)

export default component.exports